import { amber, blueGrey, grey, lightBlue, red } from "@mui/material/colors";

export const RFQ_PRIORITY_OPTIONS = [
  {
    value: 0,
    label: "Low Priority",
    indicatorSx: {
      width: 10,
      height: 10,
      backgroundColor: blueGrey[100],
      border: "1px solid",
      borderColor: grey[700],
      borderRadius: "50%",
    },
  },
  {
    value: 1,
    label: "Medium Priority",
    indicatorSx: {
      width: 10,
      height: 10,
      border: "1px solid",
      borderColor: grey[700],
      backgroundColor: lightBlue[200],
      borderRadius: "50%",
    },
  },
  {
    value: 2,
    label: "High Priority",
    indicatorSx: {
      width: 13,
      height: 13,
      border: "1px solid",
      borderColor: grey[700],
      backgroundColor: amber[500],
      borderRadius: "50%",
    },
  },
  {
    value: 3,
    label: "Urgent Priority",
    indicatorSx: {
      width: 14,
      height: 14,
      border: "1px solid",
      borderColor: grey[700],
      backgroundColor: red[500],
      borderRadius: "50%",
    },
  },
] as const;

export function rfqPriorityOption(priority: number) {
  return (
    RFQ_PRIORITY_OPTIONS.find((option) => option.value === priority) ??
    RFQ_PRIORITY_OPTIONS[0]
  );
}
